module.exports = __webpack_public_path__ + "img/loghi_0000_Fond_pittini.1070a55a.png";